/**
 * @repo/connection-manager
 *
 * Central connection manager for all API services
 * Migrated from 3in1CMS to bfl-web-apps monorepo
 *
 * Features:
 * - 42 API services (38 fully migrated, 4 simplified)
 * - Type-safe request/response handling
 * - Redux integration
 * - SSR-safe implementations
 * - New Relic logging
 * - CleverTap analytics integration
 */

// ============================================================================
// CORE EXPORTS
// ============================================================================
export * from "./core";
export * from "./services";
export * from "./types";

// ============================================================================
// CONVENIENCE RE-EXPORTS
// ============================================================================
export { request, requestSafe } from "./core/request";
export { ConnectionManagerClient } from "./core/connection-manager";
export { OPERATION_IDS } from "./constants/operation-ids";
export { API_RESPONSE_CODES, REST_CONNECTION_FROM } from "./services/constants";
export type { IRequestParams, IResponse, IApiError } from "./core/types";

// ============================================================================
// CPR / EMIPOD CONVENIENCE RE-EXPORTS
// ============================================================================
export {
  offerSelectionRequest,
  preapplicationRequest,
  additionalDataRequest,
  csCustomerPaymentRequest,
} from "./services/cpr.service";
export type {
  IOfferSelectionReq,
  IEmipodRes,
  IModifiedEmipodRes,
  INodeRes,
  IAdditionalDataReq,
  ICscustomerPaymentReq,
  IPreapplicationReq,
} from "./types/cprTypes";

// Note: All 42 services are available via:
// import * as services from '@repo/connection-manager/services';
// import * as types from '@repo/connection-manager/types';
